import { __rest, __assign } from '../../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import * as React from 'react';
import { useController } from 'react-hook-form';
import { FormLabel, FormHint } from '../Form.styles.js';
import { TextInputWrap, Input } from './TextInput.styles.js';

var TextInput = function (_a) {
    var name = _a.name, label = _a.label, _b = _a.showError, showError = _b === void 0 ? true : _b, _c = _a.loading, loading = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.hidden, hidden = _e === void 0 ? false : _e, inputProps = __rest(_a, ["name", "label", "showError", "loading", "disabled", "hidden"]);
    var _f = useController({ name: name }), field = _f.field, fieldState = _f.fieldState;
    return (React.createElement(TextInputWrap, { "aria-label": name, loading: loading },
        label && !hidden && (React.createElement(FormLabel, { className: "styled-label", htmlFor: name }, label)),
        React.createElement(Input, __assign({ id: name, "aria-label": "".concat(name, "-").concat(loading ? "loading" : "input"), type: "".concat(hidden ? "hidden" : "text"), hasError: Boolean(fieldState.error), disabled: disabled }, inputProps, field)),
        fieldState.error && showError && (React.createElement(FormHint, { "aria-label": "".concat(name, "-error"), error: true }, fieldState.error.message))));
};

export { TextInput };
//# sourceMappingURL=TextInput.js.map
